<template>
  <div id="component-chat-log" class="m-8" v-if="chatData">
    <div v-for="(msg, index) in chatData" class="msg-grp-container" :key="index">
      <!-- If previous msg is older than current time -->
      <template v-if="index === 0">
        <vs-divider class="msg-time">
          <span>{{
            $moment(msg.created_at)
              .locale('fa')
              .format('DD MMMM YYYY') | persian_digits
          }}</span>
        </vs-divider>
      </template>
      <template v-else-if="chatData[index - 1]">
        <vs-divider v-if="!isSameDay(msg.created_at, chatData[index - 1].created_at)" class="msg-time">
          <span>{{
            $moment(msg.created_at)
              .locale('fa')
              .format('DD MMMM YYYY') | persian_digits
          }}</span>
        </vs-divider>
        <div class="spacer mt-8" v-if="!hasSentPreviousMsg(chatData[index - 1].isSent, msg.isSent)"></div>
      </template>

      <div class="flex items-start" :class="[{ 'flex-row-reverse': !msg.isSent }]">
        <template v-if="chatData[index - 1]">
          <template
            v-if="
              !hasSentPreviousMsg(chatData[index - 1].isSent, msg.isSent) ||
                !isSameDay(msg.created_at, chatData[index - 1].created_at)
            "
          >
            <avatar
              size="40px"
              class="border-2 shadow border-solid border-white m-0 flex-shrink-0"
              :class="!msg.isSent ? 'sm:ml-5 ml-3' : 'sm:mr-5 mr-3'"
              :id="senderImg(msg.isSent)"
            ></avatar>
          </template>
        </template>

        <template v-if="index === 0">
          <avatar
            size="40px"
            class="border-2 shadow border-solid border-white m-0 flex-shrink-0"
            :class="!msg.isSent ? 'sm:ml-5 ml-3' : 'sm:mr-5 mr-3'"
            :id="senderImg(msg.isSent)"
          ></avatar>
        </template>

        <template v-if="chatData[index - 1]">
          <div
            class="mr-16"
            v-if="
              !(
                !hasSentPreviousMsg(chatData[index - 1].isSent, msg.isSent) ||
                !isSameDay(msg.created_at, chatData[index - 1].created_at)
              )
            "
          ></div>
        </template>

        <div
          style="min-width: 50%;"
          class="msg break-words relative shadow-md rounded py-3 px-4 mb-2 rounded-lg max-w-sm"
          :class="{
            'bg-primary-gradient text-white': msg.isSent,
            'border border-solid border-transparent bg-white': !msg.isSent
          }"
        >
          <span v-if="msg.type === 'text'">{{ msg.artifacts.join() | persian_digits }}</span>
          <template v-if="msg.type === 'file'">
            <download-files :files="msg.artifacts" />
          </template>
          <br />
          <vs-row class="mt-2">
            <small class="font-light">{{
              $moment(msg.created_at)
                .locale('fa')
                .format('HH:mm') | persian_digits
            }}</small>
            <vs-spacer />
            <template v-if="msg.isSent">
              <vs-icon icon="check" />
              <vs-icon icon="check" v-if="msg.state === 'visited'" />
            </template>
          </vs-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from '@/views/components/common/Avatar'
import DownloadFiles from '@/views/components/forms/DownloadFiles'

export default {
  components: {
    DownloadFiles,
    Avatar
  },
  props: {
    userId: {
      type: String,
      required: true
    }
  },
  computed: {
    chatData() {
      return this.$store.getters['chat/chatDataOfUser'](this.userId)
    },
    activeUserImg() {
      return this.$store.state.AppActiveUser.avatar
    },
    senderImg() {
      return isSentByActiveUser => {
        if (isSentByActiveUser) return this.$store.state.AppActiveUser.avatar
        else return this.$store.getters['chat/contact'](this.userId).avatar
      }
    },
    hasSentPreviousMsg() {
      return (last_sender, current_sender) => last_sender === current_sender
    }
  },
  methods: {
    isSameDay(time_to, time_from) {
      const date_time_to = new Date(Date.parse(time_to))
      const date_time_from = new Date(Date.parse(time_from))
      return (
        date_time_to.getFullYear() === date_time_from.getFullYear() &&
        date_time_to.getMonth() === date_time_from.getMonth() &&
        date_time_to.getDate() === date_time_from.getDate()
      )
    },
    scrollToBottom() {
      this.$nextTick(() => {
        this.$parent.$el.scrollTop = this.$parent.$el.scrollHeight
      })
    }
  },
  updated() {
    this.scrollToBottom()
  },
  mounted() {
    this.scrollToBottom()
  }
}
</script>
